/**
 * Password-style mask for API-redacted sensitive fields — plan/38.
 * `null` / `undefined` = redacted (server omitted the real value).
 */
export function RedactedMoney({
  value,
  className,
}: {
  value: string | null | undefined;
  className?: string;
}) {
  if (value == null) {
    return (
      <span
        className={
          className ??
          "tracking-[0.2em] text-[var(--color-muted-fg)] select-none"
        }
        title="Hidden — no permission to view"
        aria-label="Hidden"
      >
        ••••••••
      </span>
    );
  }
  return (
    <span className={className ?? "font-mono tabular-nums"}>{value}</span>
  );
}
